if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.currentIndex = 0;
        this.pointerStart = null;
        this.content = this.querySelector('.product-media-modal__content');
        this.previousButton = this.querySelector('[data-modal-previous]');
        this.nextButton = this.querySelector('[data-modal-next]');
        this.zoomButton = this.querySelector('.product-media-modal__zoom');
        this.currentCounter = this.querySelector('[data-modal-current]');
        this.totalCounter = this.querySelector('[data-modal-total]');

        this.previousButton?.addEventListener('click', () => this.showRelativeMedia(-1));
        this.nextButton?.addEventListener('click', () => this.showRelativeMedia(1));
        this.zoomButton?.addEventListener('click', () => this.toggleZoom());
        this.content?.addEventListener('click', (event) => {
          if (event.target.matches('img') && !this.ignoreNextImageClick) this.toggleZoom();
          this.ignoreNextImageClick = false;
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.showRelativeMedia(-1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.showRelativeMedia(1);
          }
        });

        this.addEventListener('pointerdown', this.onPointerDown.bind(this), true);
        this.addEventListener('pointerup', this.onPointerUp.bind(this), true);
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.mediaItems = Array.from(this.content?.querySelectorAll(':scope > [data-media-id]') || []);
        const requestedMediaId = this.openedBy?.getAttribute('data-media-id');
        const requestedIndex = this.mediaItems.findIndex((item) => item.dataset.mediaId === requestedMediaId);

        this.showMedia(requestedIndex >= 0 ? requestedIndex : 0);
      }

      showMedia(index) {
        if (!this.mediaItems?.length) return;

        window.pauseAllMedia();
        this.resetZoom();
        this.currentIndex = (index + this.mediaItems.length) % this.mediaItems.length;

        this.mediaItems.forEach((item, itemIndex) => {
          const isActive = itemIndex === this.currentIndex;
          item.classList.toggle('active', isActive);
          item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        if (this.currentCounter) this.currentCounter.textContent = this.currentIndex + 1;
        if (this.totalCounter) this.totalCounter.textContent = this.mediaItems.length;

        const hasMultipleMedia = this.mediaItems.length > 1;
        if (this.previousButton) this.previousButton.hidden = !hasMultipleMedia;
        if (this.nextButton) this.nextButton.hidden = !hasMultipleMedia;

        const activeMedia = this.mediaItems[this.currentIndex];
        const isImage = activeMedia?.matches('img');
        if (this.zoomButton) this.zoomButton.hidden = !isImage;
        this.content?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      }

      showRelativeMedia(direction) {
        if (!this.mediaItems?.length) return;
        this.showMedia(this.currentIndex + direction);
      }

      toggleZoom() {
        const activeMedia = this.mediaItems?.[this.currentIndex];
        if (!activeMedia?.matches('img')) return;

        const isZoomed = this.classList.toggle('is-zoomed');
        this.zoomButton?.setAttribute('aria-pressed', String(isZoomed));
        this.zoomButton?.setAttribute('aria-label', isZoomed ? 'Reset image zoom' : 'Zoom image');

        if (!isZoomed) this.content?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      }

      resetZoom() {
        this.classList.remove('is-zoomed');
        this.zoomButton?.setAttribute('aria-pressed', 'false');
        this.zoomButton?.setAttribute('aria-label', 'Zoom image');
      }

      onPointerDown(event) {
        if (
          !this.hasAttribute('open') ||
          this.classList.contains('is-zoomed') ||
          !this.content?.contains(event.target)
        )
          return;
        this.pointerStart = { x: event.clientX, y: event.clientY };
      }

      onPointerUp(event) {
        const dialog = event.target.closest('.product-media-modal__dialog');
        const isInsideDialog = Boolean(dialog);
        const clickedBackdrop = event.target === dialog || event.target === this.content;
        if (isInsideDialog) event.stopImmediatePropagation();
        if (!this.pointerStart || !this.content?.contains(event.target)) {
          this.pointerStart = null;
          return;
        }

        const distanceX = event.clientX - this.pointerStart.x;
        const distanceY = event.clientY - this.pointerStart.y;
        this.pointerStart = null;

        if (Math.abs(distanceX) >= 50 && Math.abs(distanceX) > Math.abs(distanceY)) {
          this.ignoreNextImageClick = true;
          this.showRelativeMedia(distanceX < 0 ? 1 : -1);
          return;
        }

        if (clickedBackdrop) this.hide();
      }
    }
  );
}
